// this function is used to determine if a link should be nofollowed
// based on the uri  => all competitor links should be nofollowed
export const useNoFollowLink = (uri: string): boolean => {
  switch (true) {
    case uri.includes('adobe.com'):
    case uri.includes('aha.io'):
    case uri.includes('airtable.com'):
    case uri.includes('asana.com'):
    case uri.includes('atlassian.com'):
    case uri.includes('canny.io'):
    case uri.includes('claude.io'):
    case uri.includes('clickup.com'):
    case uri.includes('chatgpt.com'):
    case uri.includes('coda.io'):
    case uri.includes('craft.io'):
    case uri.includes('featureupvote.com'):
    case uri.includes('feedier.com'):
    case uri.includes('fider.io'):
    case uri.includes('figma.com'):
    case uri.includes('gemini.google.com'):
    case uri.includes('glidr.io'):
    case uri.includes('hotjar.com'):
    case uri.includes('invisionapp.com'):
    case uri.includes('lattice.com'):
    case uri.includes('miro.com'):
    case uri.includes('mixpanel.com'):
    case uri.includes('monday.com'):
    case uri.includes('nulab.com'):
    case uri.includes('qualaroo.com'):
    case uri.includes('pendo.io'):
    case uri.includes('perdoo.com'):
    case uri.includes('productboard.com'):
    case uri.includes('productplan.com'):
    case uri.includes('prodpad.com'):
    case uri.includes('rapidr.io'):
    case uri.includes('roadmunk.com'):
    case uri.includes('scoro.com'):
    case uri.includes('surveysparrow.com'):
    case uri.includes('trello.com'):
    case uri.includes('typeform.com'):
    case uri.includes('userbrain.com'):
    case uri.includes('usersnap.com'):
    case uri.includes('userpilot.com'):
    case uri.includes('uservoice.com'):
    case uri.includes('uxcam.com'):
    case uri.includes('visor.us'):
    case uri.includes('workboard.com'):
    case uri.includes('wrike.com'):
      return true
    default:
      return false
  }
}
